import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const mockSegments = [
  { id: '1', name: 'НДС — актуальное', filters: { type: 'federal_law', status: 'active', date_from: '2024-01-01' }, is_public: false, notify_email: true, doc_count: 247 },
  { id: '2', name: 'Трудовое законодательство', filters: { authority: 'Минтруд' }, is_public: false, notify_email: false, doc_count: 1892 },
  { id: '3', name: 'Налоговый кодекс — изменения', filters: { title: 'Налоговый кодекс', status: 'amended' }, is_public: true, notify_email: true, doc_count: 34 },
  { id: '4', name: 'Постановления Правительства РФ 2025', filters: { type: 'resolution', authority: 'Правительство РФ', date_from: '2025-01-01' }, is_public: false, notify_email: true, doc_count: 156 },
];

export const SegmentsPage: React.FC = () => {
  const [showCreate, setShowCreate] = useState(false);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h4 className="fw-bold mb-0">Сегменты</h4>
        <button className="btn btn-primary" onClick={() => setShowCreate(!showCreate)}>
          <i className="bi bi-plus-lg me-1"></i>Новый сегмент
        </button>
      </div>

      {showCreate && (
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body">
            <h6 className="fw-bold mb-3">Создание сегмента</h6>
            <div className="row g-3">
              <div className="col-md-4">
                <label className="form-label small text-muted">Название</label>
                <input type="text" className="form-control" placeholder="Например: НДС — актуальное" />
              </div>
              <div className="col-md-3">
                <label className="form-label small text-muted">Тип документа</label>
                <select className="form-select">
                  <option>Все</option>
                  <option>Федеральный закон</option>
                  <option>Постановление</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label small text-muted">Статус</label>
                <select className="form-select">
                  <option>Все</option>
                  <option>Действует</option>
                  <option>Изменён</option>
                </select>
              </div>
              <div className="col-md-2 d-flex align-items-end">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" id="notify" />
                  <label className="form-check-label small" htmlFor="notify">Email-уведомления</label>
                </div>
              </div>
            </div>
            <div className="mt-3">
              <button className="btn btn-primary btn-sm">Сохранить сегмент</button>
              <button className="btn btn-light btn-sm ms-2" onClick={() => setShowCreate(false)}>Отмена</button>
            </div>
          </div>
        </div>
      )}

      <div className="row g-3">
        {mockSegments.map((seg) => (
          <div key={seg.id} className="col-md-6 col-xl-4">
            <div className="card border-0 shadow-sm h-100">
              <div className="card-body">
                <div className="d-flex justify-content-between align-items-start mb-2">
                  <h6 className="fw-bold mb-0">{seg.name}</h6>
                  {seg.is_public && <span className="badge bg-info">Публичный</span>}
                </div>
                <div className="mb-3">
                  {Object.entries(seg.filters).map(([k, v]) => (
                    <span key={k} className="badge bg-light text-dark me-1 mb-1" style={{ fontSize: '11px' }}>
                      {k}: {String(v)}
                    </span>
                  ))}
                </div>
                <div className="d-flex align-items-center justify-content-between">
                  <span className="text-muted small">{seg.doc_count?.toLocaleString()} документов</span>
                  <div className="d-flex gap-1">
                    {seg.notify_email && <i className="bi bi-envelope-check text-success" title="Email-уведомления включены"></i>}
                    <Link to={`/search?segment=${seg.id}`} className="btn btn-sm btn-outline-primary">Открыть</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
